<div class="row mb-2">
  <div class="col-sm-4 p-field">
    <label class="d-block mb-1" style="font-size: 0.8rem">Operación:</label>
    <p-dropdown
      [options]="operations"
      [(ngModel)]="selectedOperation"
      [showClear]="true"
      optionLabel="label"
      (onChange)="onChangeOperation()"
      [placeholder]="placeholderOperation"
      [disabled]="disabledOperation"
      [style]="{ width: '100%' }"
      appendTo="body"
      [disabled]="disabled"
    ></p-dropdown>
  </div>
  <div class="col-sm-4 p-field">
    <label class="d-block mb-1" style="font-size: 0.8rem">Grupo:</label>
    <p-dropdown
      [options]="groups"
      [(ngModel)]="selectedGroup"
      [showClear]="true"
      optionLabel="label"
      (onChange)="onChangeGroup()"
      [placeholder]="placeholderGroup"
      [disabled]="disabledGroup"
      [style]="{ width: '100%' }"
      appendTo="body"
    ></p-dropdown>
  </div>
  <div class="col-sm-4 p-field">
    <label class="d-block mb-1" style="font-size: 0.8rem">Convoy:</label>
    <p-dropdown
      [options]="convoys"
      [(ngModel)]="selectedConvoy"
      [showClear]="true"
      optionLabel="label"
      (onChange)="onChangeConvoy()"
      [placeholder]="placeholderConvoy"
      [disabled]="disabledConvoy"
      [style]="{ width: '100%' }"
      appendTo="body"
    ></p-dropdown>
  </div>
</div>
